// CPC LOCAL: epoch + checkpoint from RPC / Push Hub (no getLatestSuiSystemState).

import { formatAmountParts, formatDate } from '@mysten/core';
import { Heading, Text } from '@mysten/ui';
import { format } from 'date-fns';

import { StatsWrapper } from '~/components/HomeMetrics/FormattedStatsAmount';
import { useCpcHomeStats } from '~/hooks/useCpcHomeStats';
import { useEpochProgress } from '~/pages/epochs/utils';
import { Card } from '~/ui/Card';
import { LinkWithQuery } from '~/ui/utils/LinkWithQuery';

export function CpcCurrentEpoch() {
	const stats = useCpcHomeStats();
	const { epoch: rpcEpoch, progress, label } = useEpochProgress('left');
	const epochLabel =
		rpcEpoch ?? (stats.epoch != null ? formatAmountParts(stats.epoch)[0] : null);
	const checkpointLabel =
		stats.checkpointSeq != null ? BigInt(stats.checkpointSeq).toLocaleString() : null;

	const checkpointTime =
		stats.hub?.trade_stats?.last_timestamp_ms != null
			? new Date(stats.hub.trade_stats.last_timestamp_ms)
			: null;

	const progressPct = progress != null ? Math.round(progress) : null;

	return (
		<LinkWithQuery to={epochLabel != null ? `/epoch/${epochLabel}` : '/epochs'}>
			<Card growOnHover bg="dark" height="full" spacing="lg">
				<div className="flex flex-col gap-2">
					<Heading color="success-dark" variant="heading4/semibold">
						Epoch {epochLabel ?? '--'}
					</Heading>
					{progressPct != null ? (
						<div className="mt-1">
							<div className="flex items-center justify-between text-xs text-[#aeb9d0] mb-1">
								<span>Epoch 进度</span>
								<span className="tabular-nums">{label ?? `${progressPct}%`}</span>
							</div>
							<div className="h-1.5 rounded-full bg-[#1E293B] overflow-hidden">
								<div
									className="h-full rounded-full bg-success transition-all duration-500"
									style={{ width: `${progressPct}%` }}
								/>
							</div>
						</div>
					) : null}
					<Text variant="pSubtitle/semibold" color="dark">
						{checkpointTime
							? `Last CLOB trade ${format(checkpointTime, 'p')}, ${formatDate(checkpointTime, ['day', 'month'])}`
							: 'Epoch timing from fullnode indexer unavailable'}
					</Text>
					<StatsWrapper
						label="Checkpoint"
						tooltip="Latest checkpoint from Push Hub / fullnode RPC"
						size="sm"
						orientation="horizontal"
						color="dark"
					>
						{checkpointLabel}
					</StatsWrapper>
					<StatsWrapper
						label="CLOB Events"
						tooltip="CLOB package events indexed by Event Receiver"
						size="sm"
						orientation="horizontal"
						color="dark"
					>
						{stats.chainEvents != null ? stats.chainEvents.toLocaleString() : null}
					</StatsWrapper>
				</div>
			</Card>
		</LinkWithQuery>
	);
}
